import polyglotI18nProvider from 'ra-i18n-polyglot';

import { LOCALE } from '../env';
import enMessages from './en';
import jaMessages from './ja';

const messages = {
  en: enMessages,
  ja: jaMessages,
  gh: enMessages,
}

const i18nProvider = polyglotI18nProvider(locale => messages[locale], LOCALE);

export default i18nProvider;
